<app-public-top-nav class="top-navbar" [fullWidthNav]="fullWidthNav"></app-public-top-nav>

<div class="router-container" [class.-component-loading]="firstLoading || componentIsLoading">
  <div class="public-area-container">
    <router-outlet (activate)="onActivate()" (deactivate)="onDeactivate()"></router-outlet>
  </div>
</div>
